import { useCallback, useState } from 'react';
import type { NavigationProp, ParamListBase } from '@react-navigation/native';
import { useOrganizationSwitcherAccess } from './useOrganizationSwitcherAccess';

/**
 * Abre el sheet "Tus negocios" desde Perfil, Organización u otros puntos del shell.
 * En mobile no hay sidebar: este hook es el entry point fuera del hub post-login.
 */
export function useOrganizationSwitcherSheet(navigation: NavigationProp<ParamListBase>) {
  const { canOpenOrganizationMenu, organizationCount, refresh } = useOrganizationSwitcherAccess();
  const [visible, setVisible] = useState(false);

  const open = useCallback(() => {
    void refresh();
    setVisible(true);
  }, [refresh]);

  const close = useCallback(() => setVisible(false), []);

  return {
    navigation,
    visible,
    open,
    close,
    canOpenOrganizationMenu,
    organizationCount,
  };
}
